import { checkKnownDateOrString } from "../";
import _ from "lodash";
import Grid from "@mui/material/Grid";

export function ApprovalDetails({ data }) {
  return Object.keys(data).map((oneKey, i) => {
    return (
      <Grid container key={i}>
        <Grid item xs={12} sm={5}>
          <span>{_.startCase(Object.keys(data)[i]) + ":"}</span>
        </Grid>

        <Grid item xs={12} sm={7}>
          <span>{checkKnownDateOrString(oneKey, data[oneKey])}</span>
        </Grid>
      </Grid>
    );
  });
}
